// Topbar help dropdown — triggers product tour + help links.
import React from "react";
import { useNavigate } from "react-router-dom";
import { HelpCircle, Rocket, LifeBuoy, Mail } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Button } from "../ui/button";
import { useProductTour } from "../../contexts/ProductTourContext";

export default function HelpMenu() {
  const { start } = useProductTour();
  const navigate = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="help-btn"
          variant="ghost"
          size="icon"
          aria-label="Aide"
        >
          <HelpCircle className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      {/* w-48 (192px) au lieu de w-56 (224px) — évite le débordement viewport sur mobile (V0-T7) */}
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel>Centre d'aide</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          data-testid="help-tour-btn"
          onClick={start}
          className="gap-2"
        >
          <Rocket className="h-4 w-4 text-primary" /> Visite guidée
        </DropdownMenuItem>
        {/* V0-T6 : lien Centre d'aide → /help/roles (page existante) */}
        <DropdownMenuItem
          data-testid="help-center-btn"
          onClick={() => navigate("/help/roles")}
          className="gap-2 cursor-pointer"
        >
          <LifeBuoy className="h-4 w-4 text-muted-foreground" />
          Centre d'aide
        </DropdownMenuItem>
        {/* V0-T6 : mailto réel au lieu de placeholder */}
        <DropdownMenuItem asChild>
          <a
            data-testid="help-contact-btn"
            href="mailto:contact@flowbtp.fr"
            className="gap-2 flex items-center"
          >
            <Mail className="h-4 w-4 text-muted-foreground" />
            Contactez-nous
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
